export const EVENT_SAVINGS_ACCOUNT_UPDATE = 'savingsAccount.update'
export const EVENT_SAVINGS_ACCOUNT_TRANSACTION_UPDATE = 'savingsAccountTransaction.update'
export const EVENT_SAVINGS_ACCOUNT_RATE_CHANGE = 'savingsAccountRate.change'
